import './bootstrap';
import './component.js';
